/**
 * Pro features included on the trial plan that must not outlive an expired trial.
 * Non-paid users need an active trial period; stale license features after downgrade are ignored.
 *
 * This covers editing too, not just creating: once the trial is over, entries the user
 * created while it was running become read-only (they stay visible, they are never deleted).
 * That is why `add_grades` and `add_notes` are listed here rather than relying on
 * `hasPermission` alone — a downgraded license often still lists the feature.
 */
export const TRIAL_EXPIRY_GATED_FEATURES = [
  'presentation_mode',
  'calendar_personal_events',
  'calendar_vacation',
  'calendar_additional_periods',
  'add_grades',
  'add_notes',
] as const;

export type TrialExpiryGatedFeature =
  (typeof TRIAL_EXPIRY_GATED_FEATURES)[number];

export function isTrialExpiryGatedFeature(
  feature: string,
): feature is TrialExpiryGatedFeature {
  return (TRIAL_EXPIRY_GATED_FEATURES as readonly string[]).includes(feature);
}
